<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="page_v"></a>CONTENTS</h2>
<p class="toc"><a href="#/xhtml/acknowledgments#ack">Acknowledgments</a></p>
<p class="toc"><a href="#/xhtml/names#nam">Notes on Transliteration, Translation, and Names</a></p>
<p class="toc"><a href="#/xhtml/introduction#int">Introduction</a></p>
<p class="toc"><a href="#/xhtml/part01#part1"><strong>Part I—Revolution</strong></a></p>
<p class="toc"><a href="#/xhtml/chapter01#ch1">1. Making Jews Bolsheviks</a></p>
<p class="toc"><span href="#/xhtml/part02#part2" title="Link target outside of Sample"><strong>Part II—Capital and Labor</strong></span></p>
<p class="toc"><span href="#/xhtml/chapter02#ch2" title="Link target outside of Sample">2. Speculators, Swindlers, and Other Jews: Regulating Trade in Revolutionary White Russia</span></p>
<p class="toc"><span href="#/xhtml/chapter03#ch3" title="Link target outside of Sample">3. Jewish Proletarians and Proletarian Jews: The Emancipation of Labor in NEP Society</span></p>
<p class="toc"><span href="#/xhtml/part03#part3" title="Link target outside of Sample"><strong>Part III—Political Culture and Nationality</strong></span></p>
<p class="toc"><span href="#/xhtml/chapter04#ch4" title="Link target outside of Sample">4. From Bolshevik <em>Haskole</em> to Cultural Revolution: Abram Beilin and the Jewish Revolution</span></p>
<p class="toc"><a id="page_vi"></a><span href="#/xhtml/chapter05#ch5" title="Link target outside of Sample">5. Bundism and the Nationalities Question</span></p>
<p class="toc"><span href="#/xhtml/part04#part4" title="Link target outside of Sample"><strong>Part IV—The Politics of Crisis</strong></span></p>
<p class="toc"><span href="#/xhtml/chapter06#ch6" title="Link target outside of Sample">6. The Politics of Crisis: Economy, Ethnicity, and Trotskyism</span></p>
<p class="toc"><span href="#/xhtml/chapter07#ch7" title="Link target outside of Sample">7. Antisemitism and the Stalin Revolution</span></p>
<p class="toc"><span href="#/xhtml/conclusion#con" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc"><span href="#/xhtml/appendix#app" title="Link target outside of Sample">Appendix: Tables</span></p>
<p class="toc"><span href="#/xhtml/notes#not" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample">Selected Bibliography</span></p>
<p class="toc"><span href="#/xhtml/index#ind" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6f7d92ec